import { render, staticRenderFns } from "./CambiarModalComponent.vue?vue&type=template&id=71b18395&"
import script from "./CambiarModalComponent.vue?vue&type=script&lang=js&"
export * from "./CambiarModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports